module.exports = __webpack_public_path__ + "static/media/link-logo-thomson.496e2b69.jpg";